var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-option"},[_c('div',[_vm._t("default")],2),_c('Checkbox',{attrs:{"value":_vm.value},on:{"change":function($event){return _vm.$emit('change', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }